import { addPageAction } from '../util/new_relic.js';

// https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=adobedotcom&title=Privacy#Privacy-Handlingeventsandloadingadditionalscripts
const PERFORMANCE_COOKIE_NAME = 'C0002';
const TOP_APP_BAR_CLIENT_ID = 'fonts';
const TOP_APP_BAR_THEME = 'light';

const ANALYTICS_CONTEXT = {
  disableEvents: false,
  consumer: {
    name: 'Adobe Fonts',
    version: '1.0',
    platform: 'Web',
    device: 'na',
    os_version: 'na'
  }
};

class TopAppBar extends HTMLElement {
  async connectedCallback() {
    const contentTarget = this.querySelector('#top-app-bar-content-target');
    const toggleTarget = document.querySelector('#top-app-bar-toggle-target');
    if (!contentTarget || !toggleTarget) {
      return;
    }

    try {
      this._initTopAppBar(contentTarget, toggleTarget);
    } catch (error) {
      if (this.getAttribute('env') !== 'prod') {
        console.error('There was an error loading TopAppBar:', error);
      }
    }
  }

  _initTopAppBar(contentTarget, toggleTarget) {
    if (window.TopAppBar) {
      if (window.TopAppBar.load) {
        window.TopAppBar.load({
          contentTarget,
          toggleTarget,
          clientId: TOP_APP_BAR_CLIENT_ID
        });
      }

      if (window.TopAppBar.setConfig) {
        const locale = this.getAttribute('locale');
        this._setAnalyticsContext();

        window.TopAppBar.setConfig({
          locale,
          analyticsContext: ANALYTICS_CONTEXT
        });
      }

      if (window.TopAppBar.updateTheme) {
        window.TopAppBar.updateTheme(TOP_APP_BAR_THEME);
      }

      window._afTopAppBarInitialized = true;
    }
  }

  /**
   * Determine whether or not to disable analytics on the TopAppBar for the user
   * based on their cookie preferences.
   *
   * @returns {void}
   */
  _setAnalyticsContext() {
    const disableAnalytics = window.adobePrivacy && !window.adobePrivacy.activeCookieGroups().includes(PERFORMANCE_COOKIE_NAME);
    ANALYTICS_CONTEXT.disableEvents = disableAnalytics;
    ANALYTICS_CONTEXT.onAnalyticsEvent = (event) => {
      if (disableAnalytics) {
        return;
      }

      // we pass in the entire event object since there are multiple properties
      // that track each event type; and they are not all within the event.event object
      addPageAction(`typekit.top-app-bar.${event.event.type}`, event);
    };
  }
}

customElements.define('af-top-app-bar', TopAppBar);
